/* Some of our jQuery DOM selectors do not explictly search for hidden elements,
so we use this hacky class to hide the content. Used to hide stage tasks when
there are 0 tasks. */
.jQuery-compatible-hidden {
    opacity: 0;
    visibility: hidden;
    pointer-events: none;
    position: absolute;
    top: 10000px;
    left: 10000px;
    overflow: hidden;
}

.pipeline-tasks-header--content {
    margin-bottom: -16px;
}
